export const getCommonLoading = state => state.common.isLoading;

export const getCommonJob = state => state?.common?.commonJob || {};

export const getCommonCompany = state => getCommonJob(state).company || {};

export const getCommonJobLang = state => getCommonJob(state).default_language;

export const getCommonError = state => state?.common?.error;
